import React from "react";

export default function WebviewContent() {
    return <h1>Webview content</h1>
}